export interface NewsArticle {
  id: string;
  title: string;
  summary: string;
  categoryId: string;
  tags: string[];
  author: string;
  source: string;
  publishedAt: string;
  views: number;
  cover: string;
  content: string[];
  topicIds: string[];
  featured?: boolean;
}

export const newsList: NewsArticle[] = [
  {
    id: "ent-001",
    title: "《长风渡月》收官夜收视破 2.1，导演首谈幕后：一场雨戏拍了九天",
    summary:
      "古装剧《长风渡月》昨晚正式收官，收官夜实时收视率突破 2.1，创下平台年度古装剧新高。导演周砚秋在采访中透露，全剧最难的一场雨戏前后拍摄了九天。",
    categoryId: "entertainment",
    tags: ["影视", "行业"],
    author: "顾南乔",
    source: "黑料吃瓜网 娱乐组",
    publishedAt: "2026-10-17T09:20:00",
    views: 48210,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20drama%20film%20set%20at%20dusk%2C%20stone%20courtyard%20with%20red%20lanterns%20and%20rain%2C%20warm%20amber%20light%20against%20deep%20maroon%20shadows%2C%20editorial%20magazine%20photography%2C%20soft%20focus%20background%2C%20rich%20texture%2C%20no%20people&width=800&height=600&seq=news-ent-001-cover&orientation=landscape",
    content: [
      "《长风渡月》在昨晚播出了最后一集，收官夜的实时收视率突破 2.1，成为该平台今年古装剧的最高纪录。剧集从开播时的不被看好，到中段口碑逆袭，讨论度几乎每隔两天就会冲上一次热搜。",
      "导演周砚秋在收官当天接受了媒体群访。她提到，全剧最难的一场戏并不是大结局的对峙，而是第十一集的那场雨戏。「那场戏我们拍了九天，第一天拍完我就知道不对，光打得太干净了，像广告。」她笑着说，最后剧组调来了两台老式洒水车，把整条街的石板路浇透，才拍出了想要的那种湿冷。",
      "主演林砚舟在剧中饰演一位被贬的年轻官员，他在社交平台发文告别角色，写道：「拍完最后一场戏，我在片场坐了很久，衣服都没换。」这条动态在发布两小时内获得超过四十万点赞。",
      "值得一提的是，该剧的配角阵容同样出彩。饰演老仆的演员韩守正今年六十七岁，这是他第一次拿到有完整人物弧光的角色。他在采访中说，自己跑了三十年龙套，「终于有人愿意让我把一个角色演完」。",
      "平台方面表示，剧集完结后将上线幕后纪录短片，包含大量未公开的片场素材。至于观众最关心的番外篇，制作方仅回应「在讨论中」，并未给出明确时间表。",
    ],
    topicIds: ["topic-drama-2026"],
    featured: true,
  },
  {
    id: "ent-002",
    title: "音乐节首日现场：万人合唱新歌，主唱哽咽说「写它的时候我三十岁」",
    summary:
      "为期三天的秋季音乐节昨日开幕，首日压轴乐队「南岸公路」带来七首曲目，新歌《三十岁的海》引发全场万人合唱，主唱在台上数度停顿。",
    categoryId: "entertainment",
    tags: ["音乐", "人物"],
    author: "苏未晚",
    source: "黑料吃瓜网 音乐组",
    publishedAt: "2026-10-17T08:05:00",
    views: 33640,
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20stage%20at%20night%20seen%20from%20the%20crowd%2C%20warm%20orange%20stage%20lights%20and%20haze%2C%20thousands%20of%20raised%20hands%20in%20silhouette%2C%20crimson%20and%20amber%20color%20palette%2C%20cinematic%20concert%20photography%2C%20grainy%20film%20look&width=800&height=600&seq=news-ent-002-cover&orientation=landscape",
    content: [
      "秋季音乐节在城郊的草坪会场开幕，首日入场人数接近四万。傍晚六点之后，主舞台前方的人群几乎无法再向前移动，安保人员每隔十分钟就要广播一次注意安全。",
      "压轴出场的是成立十二年的乐队「南岸公路」。他们一口气唱了七首，第六首是新歌《三十岁的海》。前奏刚响起，台下已经有人开始跟唱，主唱陈屿在第二段副歌时停了下来，把话筒朝向观众。",
      "「写这首歌的时候我三十岁，」他在台上说，「那时候我以为三十岁是一个很远的地方，结果它就在门口。」说完这句，他低头调整了一下吉他背带，现场安静了大概五秒。",
      "音乐节主办方透露，今年三天共设置四个舞台，参演乐队与音乐人合计四十二组，其中近三分之一是首次登上这个规模的舞台。第二天将有另一支老牌乐队登场，主办方提醒观众提前规划返程交通。",
    ],
    topicIds: ["topic-concert-economy"],
    featured: true,
  },
  {
    id: "ent-003",
    title: "新综艺《今夜不打烊》定档，六位常驻嘉宾阵容曝光",
    summary:
      "平台全新夜间谈话综艺《今夜不打烊》宣布定档十月下旬，节目采用深夜录制、无脚本对谈的形式，六位常驻嘉宾名单同步公开。",
    categoryId: "entertainment",
    tags: ["综艺"],
    author: "何清野",
    source: "黑料吃瓜网 综艺组",
    publishedAt: "2026-10-16T21:40:00",
    views: 27180,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20late%20night%20television%20studio%20set%20with%20empty%20armchairs%20and%20vintage%20microphones%2C%20amber%20practical%20lamps%20glowing%20against%20deep%20maroon%20walls%2C%20empty%20stage%2C%20editorial%20interior%20photography%2C%20soft%20grain%2C%20no%20people&width=800&height=600&seq=news-ent-003-cover&orientation=landscape",
    content: [
      "《今夜不打烊》宣布将于十月二十四日首播，节目形式被描述为「深夜客厅」：没有游戏环节，没有任务卡，六位嘉宾在一间搭出来的旧公寓里聊天，每期邀请一到两位客人。",
      "常驻阵容包括主持人出身的罗一舟、演员沈知微、喜剧人老葛、歌手陈屿、编剧唐未以及一位尚未公开身份的「素人常驻」。节目组表示，这位素人是从三百多位报名者中选出的普通上班族。",
      "「我们不想做那种每个人都抢着说话的节目，」总导演在看片会上说，「有的人一整期只说三句话，但那三句话是有用的。」她承认这种形式对剪辑的依赖很大，第一期的素材比接近四十比一。",
      "从曝光的片花来看，节目保留了大量的沉默和停顿，甚至有长达十几秒没有人说话的镜头。这种处理在当下的综艺市场里并不常见，能否被观众接受，还要等首播之后才能知道。",
    ],
    topicIds: ["topic-drama-2026"],
  },
  {
    id: "ent-004",
    title: "剧集《雾港》开机，主创首次回应改编争议",
    summary:
      "改编自同名小说的悬疑剧《雾港》昨日正式开机，面对原著读者的质疑，编剧团队在开机仪式上首次作出回应，称「改的是结构，不是人物」。",
    categoryId: "entertainment",
    tags: ["影视"],
    author: "顾南乔",
    source: "黑料吃瓜网 娱乐组",
    publishedAt: "2026-10-16T16:12:00",
    views: 21460,
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20harbor%20at%20dawn%20with%20old%20wooden%20pier%20and%20mooring%20ropes%2C%20muted%20warm%20grey%20and%20rust%20tones%2C%20thick%20mist%2C%20cinematic%20wide%20shot%2C%20moody%20atmosphere%2C%20film%20still%20aesthetic%2C%20no%20people&width=800&height=600&seq=news-ent-004-cover&orientation=landscape",
    content: [
      "《雾港》改编自五年前出版的同名悬疑小说，原著在读者群体中有相当高的口碑，因此选角与改编消息公布后，社交平台上的讨论一直不算平静。",
      "开机仪式上，编剧唐未主动提到了这件事。他说，剧集把原著的双线叙事改成了单线，「因为影视和文字不一样，观众没有耐心在两条时间线之间来回跳」。但他强调，人物的动机和结局都没有动。",
      "原著作者本人也出现在了开机现场。她在简短发言中表示，自己参与了前六集的剧本讨论，「有些地方我坚持了，有些地方我让步了，这很正常」。",
      "该剧预计拍摄四个月，取景地包括沿海的一座旧港城。制片方透露，全剧将有超过六成的场景在实景拍摄，其中包括一座已经停用多年的修船厂。",
    ],
    topicIds: ["topic-drama-2026"],
  },
  {
    id: "ent-005",
    title: "年度票房盘点：中小成本影片靠口碑逆袭，前三名都不是大制作",
    summary:
      "截至十月中旬，年度票房榜前三名中有两部是中小成本影片。业内认为，观众对「大场面」的边际兴趣正在下降，故事完成度成为更关键的因素。",
    categoryId: "entertainment",
    tags: ["影视", "行业"],
    author: "程也",
    source: "黑料吃瓜网 产业观察",
    publishedAt: "2026-10-15T19:30:00",
    views: 18920,
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20vintage%20cinema%20auditorium%20with%20rows%20of%20red%20velvet%20seats%20and%20a%20glowing%20blank%20screen%2C%20warm%20amber%20lighting%2C%20deep%20maroon%20curtains%2C%20symmetrical%20composition%2C%20editorial%20photography%2C%20soft%20dust%20in%20the%20air%2C%20no%20people&width=800&height=600&seq=news-ent-005-cover&orientation=landscape",
    content: [
      "根据公开数据统计，截至十月中旬，今年的年度票房前三名里，只有一部是投资规模超过三亿的大制作，另外两部都是成本在五千万以下的中小成本影片。",
      "这个结果放在五年前几乎不可想象。一位发行公司负责人在接受采访时说，过去几年行业形成了一个惯性：档期越大，越要堆场面。但今年几部大制作的失利说明，观众已经不太愿意为单纯的视觉奇观买单。",
      "与之相对的是，几部小成本影片凭借口碑实现了长线放映。其中一部讲述小城家庭故事的影片，首日排片占比不足百分之八，最终靠观众自发推荐放映了整整两个月。",
      "不过也有从业者提醒，不要因此过度解读。「中小成本的成功率依然很低，」一位制片人说，「我们看到的这三部，是从几百部里活下来的。」",
    ],
    topicIds: ["topic-copyright-rules"],
  },
  {
    id: "ent-006",
    title: "秋冬时装周街拍观察：复古廓形回潮，颜色却越来越安静",
    summary:
      "本季时装周场外街拍中，宽肩廓形与低饱和色系成为主流。造型师认为，这是一种「看起来不费力」的策略，也是一种对过度造型的反向选择。",
    categoryId: "entertainment",
    tags: ["时尚", "人物"],
    author: "黎见",
    source: "黑料吃瓜网 时尚组",
    publishedAt: "2026-10-15T11:45:00",
    views: 14350,
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20fashion%20still%20life%20of%20a%20beige%20oversized%20wool%20coat%20draped%20over%20a%20vintage%20wooden%20chair%2C%20warm%20cream%20studio%20background%2C%20soft%20window%20light%2C%20minimal%20composition%2C%20rich%20fabric%20texture%2C%20no%20people&width=800&height=600&seq=news-ent-006-cover&orientation=landscape",
    content: [
      "本季时装周的场外街拍有一个很明显的变化：颜色变少了。往年那种大面积撞色的造型几乎消失，取而代之的是米色、灰褐、深棕这类低饱和度的搭配。",
      "廓形上则在往回走。宽肩外套、直筒长裤、略带垫肩的西装重新出现，和几年前流行的紧身剪裁形成对比。一位造型师把这形容为「身体重新获得了空间」。",
      "「其实这跟经济情绪有关，」他补充说，「大家不太想在衣服上表现得用力过猛。」这个说法在业内并不新鲜，但今年的确能从街拍里直观地看到。",
      "配饰方面，体积感明显缩小。过去几季流行的大耳环和宽腰带被更细的金属链条取代，包袋也回到了中号。唯一没有变的是鞋：厚底乐福鞋依然是场外出现频率最高的单品。",
    ],
    topicIds: [],
  },
  {
    id: "gos-001",
    title: "林星野与苏念被拍同回公寓，双方工作室暂未回应",
    summary:
      "有网友在社交平台晒出照片，称拍到演员林星野与苏念深夜同回一处公寓。截至发稿，双方工作室均未对此作出回应。",
    categoryId: "gossip",
    tags: ["情感", "人物"],
    author: "陶然",
    source: "黑料吃瓜网 八卦组",
    publishedAt: "2026-10-17T10:02:00",
    views: 96380,
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20with%20blurred%20warm%20streetlights%20and%20wet%20pavement%20reflections%2C%20an%20umbrella%20and%20two%20distant%20silhouettes%20walking%20away%2C%20cinematic%20paparazzi%20style%20photography%2C%20amber%20and%20deep%20maroon%20tones%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=news-gos-001-cover&orientation=landscape",
    content: [
      "今天上午，一位网友在社交平台发布了三张照片，称前一晚在某小区门口拍到演员林星野与苏念先后下车，并一同进入公寓楼。照片拍摄距离较远，人物面部并不清晰。",
      "该网友表示，自己只是路过，并没有跟拍。照片发布后两小时内转发量超过两万，相关话题进入热搜榜前十，但随后被平台标注为「内容真实性待核实」。",
      "两人此前合作过一部都市剧，在剧中饰演一对分分合合的情侣。剧集播出期间，两人的互动曾被观众反复解读，但当时双方都没有正面回应过相关传闻。",
      "截至发稿，林星野与苏念的工作室均未就此事发表任何声明。有媒体尝试联系两人的经纪人，电话未获接听。需要提醒的是，目前公开的信息仅为网友单方面描述，尚无更多独立信源。",
    ],
    topicIds: ["topic-celebrity-romance"],
    featured: true,
  },
  {
    id: "gos-002",
    title: "陈亦然新剧片场路透：连续三天夜戏，状态引关注",
    summary:
      "有剧组工作人员在社交平台透露，陈亦然为新剧连续三天拍摄夜戏，其中一场需要在雨中反复走位。相关路透照片引发粉丝对其身体状况的担心。",
    categoryId: "gossip",
    tags: ["片场", "人物"],
    author: "陶然",
    source: "黑料吃瓜网 八卦组",
    publishedAt: "2026-10-16T22:18:00",
    views: 52170,
    cover:
      "https://readdy.ai/api/search-image?query=Film%20set%20at%20night%20with%20lighting%20stands%20and%20cables%20on%20a%20wet%20cobblestone%20street%2C%20warm%20key%20light%20cutting%20through%20mist%2C%20crew%20silhouettes%20in%20the%20background%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20deep%20amber%20and%20charcoal%20tones&width=800&height=600&seq=news-gos-002-cover&orientation=landscape",
    content: [
      "一位自称剧组工作人员的网友昨晚发文，称陈亦然所在剧组已经连续三天拍摄夜戏，每天收工时间都在凌晨三点之后。文中提到，有一场雨戏需要演员在积水里反复走位近二十次。",
      "随后有粉丝在超话整理了他近半个月的公开行程，发现其间只有两天没有通告。相关讨论在几个小时内积累了上万条留言，多数是希望剧组调整拍摄强度的声音。",
      "也有业内人士提醒，夜戏在影视拍摄中属于常态，尤其是外景戏受天气和场地限制，扎堆拍摄并不罕见。「当然强度确实大，」一位执行制片人说，「但这和外界想象的『被为难』不是一回事。」",
      "目前剧组方面没有回应。陈亦然本人的社交账号最后一次更新是在五天前，内容是新剧的定妆照。",
    ],
    topicIds: ["topic-celebrity-romance"],
  },
  {
    id: "gos-003",
    title: "沈知微取关风波后续：好友发声「只是手滑」",
    summary:
      "沈知微被发现取关某位合作演员后，社交平台上出现大量猜测。昨日，其好友在直播中回应称「她真的只是手滑，已经重新关注了」。",
    categoryId: "gossip",
    tags: ["情感", "人物"],
    author: "何清野",
    source: "黑料吃瓜网 八卦组",
    publishedAt: "2026-10-16T14:36:00",
    views: 41290,
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20smartphone%20screen%20glowing%20warm%20amber%20on%20a%20dark%20wooden%20table%2C%20blurred%20notification%20lights%2C%20moody%20low%20key%20editorial%20still%20life%2C%20shallow%20depth%20of%20field%2C%20deep%20maroon%20background%2C%20no%20visible%20text&width=800&height=600&seq=news-gos-003-cover&orientation=landscape",
    content: [
      "事情起因是有网友发现，沈知微的社交账号关注列表里少了一位曾合作过的男演员。由于两人上一部剧的 CP 讨论度很高，这个变化迅速被解读为「关系生变」。",
      "随后有营销号整理出所谓「时间线」，把取关时间与男演员的一条动态联系起来。相关内容在一天内被大量搬运，甚至出现了「双方团队交恶」的说法。",
      "昨天下午，沈知微的好友在直播中被问到这件事，她先是笑了一下，说「她真的只是手滑」，随后补充：「已经重新关注了，你们去看。」有网友核实，关注确实已经恢复。",
      "不过事情并没有完全平息。有评论认为，一个关注动作能被解读到这个程度，本身就说明当下的娱乐讨论已经过度依赖细节推测。也有人反驳说，公众人物的公开行为被讨论是正常的。",
    ],
    topicIds: ["topic-celebrity-romance"],
  },
  {
    id: "gos-004",
    title: "顾屿川被偶遇独自逛书店，素颜照片引热议",
    summary:
      "有网友称在城南一家独立书店偶遇顾屿川，并拍下其在文学区翻阅书籍的照片。照片中他未做造型，引发关于「明星私下状态」的讨论。",
    categoryId: "gossip",
    tags: ["人物", "时尚"],
    author: "黎见",
    source: "黑料吃瓜网 八卦组",
    publishedAt: "2026-10-15T20:05:00",
    views: 36480,
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20independent%20bookstore%20interior%20with%20tall%20wooden%20shelves%20and%20a%20single%20reading%20lamp%2C%20warm%20amber%20pool%20of%20light%2C%20stack%20of%20books%20on%20a%20stool%2C%20quiet%20editorial%20photography%2C%20soft%20film%20grain%2C%20no%20people&width=800&height=600&seq=news-gos-004-cover&orientation=landscape",
    content: [
      "一位网友发帖称，自己在城南一家独立书店遇到了顾屿川。对方戴着帽子，没有化妆，在文学区站了很久，最后买了两本书。出于礼貌，她只拍了书架和背影。",
      "帖子发出后，评论区很快分成两派。一部分人讨论他买的是什么书，另一部分人则讨论「明星素颜被拍」这件事的边界在哪里。",
      "书店店员在接受询问时确认了这次到访，但表示不希望透露具体细节。「他排队结账的，前面还有两个人，没有人打扰他。」",
      "值得一提的是，这家书店今年以来已经多次出现在艺人的社交动态里。店主说，他们并没有做特别的宣传，「可能只是这里比较安静」。",
    ],
    topicIds: [],
  },
  {
    id: "gos-005",
    title: "旧照重提引争议，许清和发文回应「那时候我才十九岁」",
    summary:
      "许清和早年的一组造型照片近日被重新翻出并引发讨论，她本人在社交平台发文回应，称那是十九岁时的一次试镜造型，希望大家不要过度解读。",
    categoryId: "gossip",
    tags: ["人物", "情感"],
    author: "苏未晚",
    source: "黑料吃瓜网 八卦组",
    publishedAt: "2026-10-15T13:22:00",
    views: 31860,
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20photography%20studio%20with%20an%20old%20film%20camera%20on%20a%20tripod%2C%20faded%20backdrop%20in%20warm%20beige%2C%20soft%20dusty%20light%20through%20a%20high%20window%2C%20nostalgic%20editorial%20still%20life%2C%20muted%20maroon%20accents%2C%20no%20people&width=800&height=600&seq=news-gos-005-cover&orientation=landscape",
    content: [
      "引发讨论的是一组拍摄于七年前的照片，照片中许清和的造型与现在的风格差异较大。有账号将照片与她近期的红毯造型并列对比，配文带有明显的调侃意味。",
      "昨天傍晚，许清和在社交平台发文回应。她写道：「那时候我才十九岁，第一次进摄影棚，造型是别人定的，我连拒绝都不知道怎么拒绝。」",
      "她同时提到，自己并不介意被讨论，「但把一个人很多年前的样子拿出来反复嘲笑，我觉得没什么意思」。这条动态目前获得超过二十万点赞。",
      "有造型师在评论区表示，那组照片是当年某部作品的试镜造型，最终并未采用。「那是很典型的试错，每个演员都有。」",
    ],
    topicIds: [],
  },
  {
    id: "gos-006",
    title: "剧组聚餐路透：宋挽歌与男二同框被拍，剧组回应「正常杀青饭」",
    summary:
      "有媒体拍到宋挽歌所在剧组聚餐的画面，她与剧中男二号相邻而坐。剧组工作人员回应称，这是常规的杀青聚餐，无其他含义。",
    categoryId: "gossip",
    tags: ["片场", "情感"],
    author: "陶然",
    source: "黑料吃瓜网 八卦组",
    publishedAt: "2026-10-14T23:10:00",
    views: 28740,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20private%20dining%20room%20in%20a%20restaurant%20with%20round%20table%2C%20empty%20chairs%2C%20hanging%20amber%20pendant%20lamps%2C%20steam%20rising%20from%20tea%20cups%2C%20red%20wood%20panels%2C%20cozy%20editorial%20interior%20photography%2C%20no%20people&width=800&height=600&seq=news-gos-006-cover&orientation=landscape",
    content: [
      "昨晚有媒体发布了一组照片，称拍到宋挽歌所在剧组在某餐厅聚餐，她与剧中男二号走出餐厅时相距不远，随后分别上车离开。",
      "照片发布后，关于两人关系的猜测迅速出现。有账号指出，两人在剧中饰演的角色并没有感情线，因此同框更显得「有故事」。",
      "今天上午，剧组一位工作人员向媒体回应：「就是正常的杀青饭，全组四十多个人都在，不能因为镜头只拍到两个人就下结论。」",
      "该剧于上周正式杀青，目前进入后期制作阶段。宋挽歌的下一部作品尚未公布。",
    ],
    topicIds: ["topic-celebrity-romance"],
  },
  {
    id: "soc-001",
    title: "演出票务平台被约谈：退改签规则将统一规范",
    summary:
      "针对近期集中出现的演出票退改签纠纷，相关部门约谈了多家票务平台，要求在一个月内统一公示退改签规则，并明确阶梯扣费标准。",
    categoryId: "society",
    tags: ["行业"],
    author: "程也",
    source: "黑料吃瓜网 社会组",
    publishedAt: "2026-10-17T07:40:00",
    views: 22140,
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20printed%20event%20tickets%20and%20a%20smartphone%20on%20a%20warm%20wooden%20desk%2C%20soft%20morning%20window%20light%2C%20neat%20editorial%20still%20life%2C%20muted%20cream%20and%20maroon%20palette%2C%20shallow%20depth%20of%20field%2C%20no%20visible%20text&width=800&height=600&seq=news-soc-001-cover&orientation=landscape",
    content: [
      "今年以来，演出市场的退改签纠纷明显增多。消费者反映的问题集中在两点：一是不清楚退票要扣多少手续费，二是不同平台、不同场次的规则差异很大。",
      "相关部门在约谈中提出三项要求：退改签规则须在购票页面显著位置公示；阶梯扣费标准须以具体金额或比例列明；不得设置「一经售出概不退换」这类排除消费者主要权利的条款。",
      "多家平台在约谈后表态将进行调整。一位平台负责人表示，技术层面的改造大概需要三到四周，「主要是要把规则细化到每一场演出，工作量比想象中大」。",
      "也有从业者提出不同看法。一位演出公司工作人员说，演出票与普通商品不同，临近开演的退票很难再次售出，「完全无条件退票，最后成本还是会转嫁到票价上」。",
    ],
    topicIds: ["topic-concert-economy", "topic-copyright-rules"],
    featured: true,
  },
  {
    id: "soc-002",
    title: "短视频搬运影视片段被判侵权，行业版权意识再受关注",
    summary:
      "一起短视频账号搬运影视片段被诉侵权的案件近日作出判决，法院认定被告构成侵权。该案的赔偿金额与认定标准引发业内讨论。",
    categoryId: "society",
    tags: ["行业"],
    author: "程也",
    source: "黑料吃瓜网 社会组",
    publishedAt: "2026-10-16T17:28:00",
    views: 19760,
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20old%20film%20reels%20and%20a%20vintage%20projector%20on%20a%20dark%20wooden%20table%2C%20warm%20amber%20light%20beam%2C%20deep%20maroon%20background%2C%20moody%20editorial%20still%20life%2C%20fine%20dust%20particles%2C%20no%20people&width=800&height=600&seq=news-soc-002-cover&orientation=landscape",
    content: [
      "案件涉及的账号在两年间发布了三百余条影视剪辑视频，其中大量内容为完整搬运剧集片段，仅做简单拼接并配上解说。权利人起诉后，法院认定其行为超出了合理使用的范围。",
      "判决书中提到，被告的视频「未对原作品进行实质性转换」，且通过流量获得了直接或间接收益，因此不构成合理使用。",
      "这一认定标准在业内被反复讨论。有律师指出，关键不在于剪辑时长，而在于是否形成了新的表达。「三分钟的解说如果只是复述剧情，那和搬运没有本质区别。」",
      "多家平台近期也在收紧相关规则，部分账号的影视剪辑内容被批量下架。有创作者表示理解，但也担心「二创」的空间被过度压缩。",
    ],
    topicIds: ["topic-copyright-rules"],
  },
  {
    id: "soc-003",
    title: "粉丝应援集资纠纷调查：钱去哪儿了",
    summary:
      "多位粉丝反映，此前参与的某次应援集资在活动结束后迟迟未公开账目。记者调查发现，此类集资往往缺乏有效监管，资金流向难以追溯。",
    categoryId: "society",
    tags: ["行业", "人物"],
    author: "闻笛",
    source: "黑料吃瓜网 调查组",
    publishedAt: "2026-10-15T15:50:00",
    views: 26310,
    cover:
      "https://readdy.ai/api/search-image?query=Scattered%20receipts%20and%20a%20ledger%20notebook%20on%20a%20warm%20wooden%20table%20beside%20a%20calculator%2C%20soft%20window%20light%2C%20documentary%20editorial%20photography%2C%20muted%20cream%20and%20rust%20tones%2C%20shallow%20depth%20of%20field%2C%20no%20readable%20text&width=800&height=600&seq=news-soc-003-cover&orientation=landscape",
    content: [
      "今年八月，一个粉丝群体为某场演出组织了应援集资，参与人数超过两千，金额从几十元到上千元不等。活动结束后，组织者仅在群内发布了一张模糊的支出截图，没有提供任何票据。",
      "多位参与者向记者表示，他们并不清楚钱具体花在了哪里。「就是相信她，」一位参与者说，「大家都是这么转的。」",
      "记者梳理发现，此类集资通常通过个人收款码或第三方小程序完成，缺乏第三方托管，账目公开完全依赖组织者的自觉。一旦出现纠纷，参与者往往难以举证。",
      "有律师提醒，粉丝集资在法律上属于赠与或委托关系，建议参与者保留转账记录与聊天记录。「更重要的是，不要因为金额小就放弃核实。」",
    ],
    topicIds: ["topic-copyright-rules"],
  },
  {
    id: "soc-004",
    title: "影视基地群演生存现状：等一场戏要站十二个小时",
    summary:
      "记者在某影视基地走访了三天，记录下群演的真实工作状态：清晨集合、长时间等待、按天结算。有人把这当作过渡，也有人已经做了十年。",
    categoryId: "society",
    tags: ["人物", "行业"],
    author: "闻笛",
    source: "黑料吃瓜网 调查组",
    publishedAt: "2026-10-14T18:20:00",
    views: 17980,
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20backlot%20of%20a%20film%20studio%20at%20dawn%2C%20rows%20of%20folding%20chairs%20and%20costume%20racks%20under%20a%20corrugated%20metal%20shed%2C%20warm%20low%20sun%20and%20dust%2C%20documentary%20photography%2C%20muted%20rust%20and%20cream%20tones%2C%20no%20people&width=800&height=600&seq=news-soc-004-cover&orientation=landscape",
    content: [
      "早上五点，影视基地门口的队伍已经排到了路口。群演们背着包，等着领队点名。有人靠着墙继续睡，有人蹲在地上吃早餐。",
      "一位做了十年的群演告诉记者，他们的工作大部分时间在等。「等集合、等化妆、等调度、等灯。真正站在镜头前的时间，可能只有二十分钟。」",
      "收入按天结算，普通群演一天一百到一百五，有台词的特约可以到三百以上。但不稳定，一个月有十天没活是常事。",
      "被问到为什么还做这行，几个人给出了不同的答案。有人说「自由」，有人说「习惯了」，也有人笑了笑说：「总觉得下一场戏可能就不一样了。」",
    ],
    topicIds: [],
  },
  {
    id: "soc-005",
    title: "演唱会临时取消后的三小时：退票、改签与道歉",
    summary:
      "一场原定于昨晚举行的演唱会因设备故障在开场前一小时宣布取消。从公告发出到观众散场，现场经历了三个小时的混乱与协调。",
    categoryId: "society",
    tags: ["行业"],
    author: "何清野",
    source: "黑料吃瓜网 社会组",
    publishedAt: "2026-10-14T11:05:00",
    views: 24670,
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20concert%20venue%20entrance%20at%20night%20with%20barrier%20fences%20and%20unlit%20stage%20lights%2C%20warm%20amber%20streetlamps%2C%20scattered%20paper%20cups%20on%20the%20ground%2C%20cinematic%20documentary%20photography%2C%20melancholic%20mood%2C%20no%20people&width=800&height=600&seq=news-soc-005-cover&orientation=landscape",
    content: [
      "晚上七点，距离演出开始还有一小时，场馆广播突然宣布当晚演出取消，原因是舞台升降设备出现故障，无法在安全前提下完成演出。",
      "消息公布时，场内已经坐了近七成观众。最初的十几分钟里，看台上出现了明显的骚动，有人高喊退票，也有人直接离场。",
      "八点十分，主办方在入口处设置了三个临时服务台，开始登记退票信息。工作人员举着手写指示牌，用扩音器反复说明流程。",
      "十点左右，主办方发布公告，承诺全额退票，并为持票观众提供下一场演出的优先购票资格，同时承担部分外地观众的车票改签费用。公告末尾附了一封道歉信。",
    ],
    topicIds: ["topic-concert-economy"],
  },
  {
    id: "soc-006",
    title: "追星族与代拍：一条街的生意",
    summary:
      "在几家公司集中的一条街上，代拍已经形成稳定的分工与价格体系。记者走访发现，这条产业链的两端，都是年轻人。",
    categoryId: "society",
    tags: ["人物", "行业"],
    author: "闻笛",
    source: "黑料吃瓜网 调查组",
    publishedAt: "2026-10-13T16:40:00",
    views: 15230,
    cover:
      "https://readdy.ai/api/search-image?query=Street%20corner%20outside%20an%20office%20building%20at%20dusk%20with%20photographers%20with%20long%20lenses%20in%20silhouette%2C%20warm%20amber%20light%20and%20long%20shadows%2C%20documentary%20street%20photography%2C%20muted%20maroon%20and%20cream%20tones&width=800&height=600&seq=news-soc-006-cover&orientation=landscape",
    content: [
      "下午四点，街角已经有人架好了长焦镜头。他们大多不说话，只是盯着大楼门口，偶尔互相通报一句「出来了」。",
      "一位做了三年的代拍说，这行的价格很透明：普通路透一组几十到几百元，独家或者清晰度高的可以上千。买家多是粉丝站子和内容账号。",
      "但这条街上的关系并不稳定。物业会驱赶，艺人团队会交涉，有时还会发生口角。「我们也知道不受欢迎，」他说，「但这确实是很多人的收入来源。」",
      "有从业者认为，代拍存在的根本原因是需求。「只要有人愿意为一张照片付钱，这条街就不会空。」至于如何规范，目前仍没有明确答案。",
    ],
    topicIds: [],
  },
  {
    id: "ent-007",
    title: "专访编剧唐未：我把最难写的部分留给了沉默",
    summary:
      "从悬疑剧到深夜谈话综艺，编剧唐未近两年的作品都在尝试「少说一点」。在这次专访中，她谈到了创作中的取舍与妥协。",
    categoryId: "entertainment",
    tags: ["人物", "影视"],
    author: "顾南乔",
    source: "黑料吃瓜网 人物",
    publishedAt: "2026-10-13T10:15:00",
    views: 13420,
    cover:
      "https://readdy.ai/api/search-image?query=Writer%20desk%20with%20a%20manual%20typewriter%2C%20stacks%20of%20marked%20script%20pages%20and%20a%20cup%20of%20tea%2C%20warm%20afternoon%20light%20through%20linen%20curtains%2C%20editorial%20still%20life%2C%20cream%20and%20maroon%20palette%2C%20no%20people&width=800&height=600&seq=news-ent-007-cover&orientation=landscape",
    content: [
      "唐未的工作室在一栋老楼的三层，桌上堆着改到第七稿的剧本。她说自己有一个习惯：每一稿都会把台词删掉百分之十，看看故事还成不成立。",
      "「大部分时候是成立的，」她说，「甚至更好。因为我们太习惯用台词解释情绪了。」",
      "谈到改编《雾港》时的争议，她承认自己做过让步。「有些情节我坚持保留，因为它们决定了人物为什么变成现在这样。但呈现方式可以谈。」",
      "采访快结束时，她提到最近在写一个没有反派的故事。「写到一半发现很难，因为没有反派，就没有人替观众承担愤怒。」",
    ],
    topicIds: ["topic-drama-2026"],
  },
  {
    id: "ent-008",
    title: "剧集营销的新套路：先让配角出圈",
    summary:
      "近期多部剧集的讨论热度并非来自主角，而是配角。业内认为，这是一种成本更低、传播更快的营销策略，但也存在反噬风险。",
    categoryId: "entertainment",
    tags: ["影视", "行业"],
    author: "程也",
    source: "黑料吃瓜网 产业观察",
    publishedAt: "2026-10-12T14:00:00",
    views: 11980,
    cover:
      "https://readdy.ai/api/search-image?query=Backstage%20corridor%20of%20a%20theater%20with%20framed%20posters%20on%20warm%20maroon%20walls%2C%20a%20single%20overhead%20lamp%20casting%20amber%20light%2C%20empty%20wooden%20bench%2C%20cinematic%20editorial%20photography%2C%20no%20people&width=800&height=600&seq=news-ent-008-cover&orientation=landscape",
    content: [
      "最近几部热播剧有一个共同点：最先出圈的往往不是主角，而是戏份不多的配角。相关片段在短视频平台被反复剪辑，播放量甚至超过主线剧情。",
      "一位剧集宣传负责人解释说，这是有意为之。「主角的物料从开拍就在铺，观众有预期。配角是意外的部分，意外更容易被讨论。」",
      "从成本上看，这也更划算。配角的短视频切片不需要单独拍摄，直接从成片里剪，投放成本极低。",
      "但风险同样存在。如果配角的讨论度超过主角，会影响后续的商务合作与番位安排。「有时候我们也会踩刹车，」她说，「但热度这个东西，不太好控制。」",
    ],
    topicIds: ["topic-drama-2026"],
  },
];